// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1qVHW","loaderOuter":"PageOverlayLoader_loaderOuter__2619H"};